import background from '../../../../assets/background-desktop.jpg';
import Spinner from '../../../../assets/loader-spinner/LoaderSpinner.png';

const LoaderSpinner = () => {
  return (
    <div
      className="bg-cover w-screen h-screen"
      style={{
        backgroundImage: `url(${background})`,
        objectFit: 'fill',
        backgroundSize: 'cover',
        backgroundRepeat: 'space',
        position: 'fixed',
        zIndex: 1000,
      }}>
      <div className="flex flex-col items-center justify-center h-screen gap-10">
        <img src={Spinner} alt="" className="animate-spinner text-indigo-500 " style={{ width: '160px', height: '160px' }} />
        <h1 className="font-[GrandSlang] text-heallopicker text-primary">Wait a second</h1>
      </div>
    </div>
  );
};

export default LoaderSpinner;
